import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { Address } from '../../../models/address';
import { Vendor } from '../../../models/vendor';

import { AddressService } from '../../../services/contacts/address.service';
import { NotyService } from '../../../services/common/noty.service';
import { VendorService } from '../../../services/accounting/vendor.service';

@Component({
  selector: 'app-contact-vendor-form',
  templateUrl: './contact-vendor-form.component.html',
  styleUrls: ['./contact-vendor-form.component.scss'],
})
export class ContactVendorFormComponent implements OnInit, OnChanges {
  /**
   * Contact id for vendors
   */
  @Input() contactId: number;

  /**
   * Vendor being created/edited
   */
  @Input() vendor: Vendor = new Vendor();

  /**
   * Addresses for the contact
   * @type {Array<Address>}
   */
  contactAddresses: Array<Address> = [];

  /**
   * Form defaults and select field options
   * @type {any}
   */
  formOptions: any = {
    chart_of_accounts: [],
  };

  /**
   * Indicates if the form has been submitted atleast once
   * @type {boolean}
   */
  formSubmitted: boolean = false;

  /**
   * Indicates if the form is submitting
   * @type {boolean}
   */
  formSubmitting: boolean = false;

  /**
   * Emit saved event to parent component
   * @param {EventEmitter<boolean> = new EventEmitter(} ) saved Event emitter to emit saved event to parent component
   */
  @Output() saved: EventEmitter<boolean> = new EventEmitter();

  constructor(private addressService: AddressService, private notyService: NotyService, private vendorService: VendorService) {
    this.vendorService.getFormOptions().then((response_json) => (this.formOptions = response_json));
  }

  // Component lifecycle methods

  /**
   * Called on Component initialization
   */
  ngOnInit() {}

  /**
   * Called when component variables change
   * @param {SimpleChanges} changes changes containing all variables changed
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) {
      this.addressService.index({ contact_id: this.contactId }).then((response_json) => (this.contactAddresses = response_json));
      if (!this.vendor.id) this.vendor.contact_id = this.contactId;
    } else if (changes.vendor && changes.vendor.currentValue) this.addressService.index({ contact_id: this.vendor.contact_id }).then((response_json) => (this.contactAddresses = response_json));
  }

  // Component methods

  /**
   * Save vendor
   */
  save() {
    this.formSubmitted = true;
    if (!this.vendor.address_id || !this.vendor.chart_of_account_id) {
      this.notyService.notify('Please check the form', 'warning', 5000, 'topRight');
      return;
    }
    this.formSubmitting = true;
    this.vendorService
      .saveVendor({ vendor: this.vendor })
      .then((response_json) => {
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Vendor saved', 'success', 5000, 'topRight');
          this.saved.emit(true);
        } else this.notyService.notify(response_json.text || 'Error saving vendor', 'error', 5000, 'topRight');
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving vendor', 'error', 5000, 'topRight');
      });
  }
}
